"use strict";

import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import { AppDispatcher } from 'Dispatcher';
import StoreClass from 'Store';
import { FormConstants } from 'Constants/Forms/FormConstants';
import { ApplicationConstants } from "Constants/ApplicationConstants";
import { Fields, System } from "Constants/objects";
import Uuid from "uuid";
import { OrderedMap } from 'immutable';
import router, { EDIT_FORM_ROUTE, SUBSYSTEM_ROUTE } from 'Router';
import { loadFormMetadata, loadSubSystem } from "D5Utils/common_requests";
import { topBarSetDynToolBarContent } from "Actions/TopBarActions";
import { changeDocumentTitle } from "Actions/ApplicationActions";
import { formatMessage, isEmptyObject, isEmptyValue } from "D5Utils/functions";
import { Messages } from "Messages";
import * as Backbone from "backbone";
var _store = {
  fullForm: new OrderedMap({}),
  modals: new OrderedMap({}),
  tables: {}
};
var CHANGE_EVENT = 'change';

var FormStoreClass =
/*#__PURE__*/
function (_StoreClass) {
  _inherits(FormStoreClass, _StoreClass);

  function FormStoreClass() {
    _classCallCheck(this, FormStoreClass);

    return _possibleConstructorReturn(this, _getPrototypeOf(FormStoreClass).apply(this, arguments));
  }

  _createClass(FormStoreClass, [{
    key: "getList",
    value: function getList() {
      return _objectSpread({}, _store);
    }
  }, {
    key: "appendFormObj",
    value: function appendFormObj(formObj, viewMode) {
      if (viewMode === System.VIEW_MODE.FULL_SCREEN && formObj.type === System.FORM_TYPE.EDIT) _store.fullForm = _store.fullForm.clear();

      if (viewMode === System.VIEW_MODE.FULL_SCREEN) {
        _store.fullForm = _store.fullForm.set(formObj.UUID, formObj);
      } else {
        _store.modals = _store.modals.set(formObj.UUID, formObj);
      }
    }
  }, {
    key: "getFormObj",
    value: function getFormObj(_ref) {
      var formID = _ref.formID,
          type = _ref.type,
          additionalData = _ref.additionalData,
          viewMode = _ref.viewMode,
          rowID = _ref.rowID,
          mode = _ref.mode,
          title = _ref.title,
          parentUUID = _ref.parentUUID;
      return {
        formID: Number(formID),
        type: Number(type),
        additionalData: additionalData || [],
        viewMode: viewMode,
        rowID: rowID,
        mode: mode,
        title: title,
        UUID: Uuid(),
        parentUUID: parentUUID
      };
    }
  }, {
    key: "isCustomForm",
    value: function isCustomForm(type) {
      var _System$FORM_TYPE = System.FORM_TYPE,
          MAIN_FORM = _System$FORM_TYPE.MAIN_FORM,
          FILTER_MODAL = _System$FORM_TYPE.FILTER_MODAL,
          SETTINGS_MODAL = _System$FORM_TYPE.SETTINGS_MODAL;
      return [MAIN_FORM, FILTER_MODAL, SETTINGS_MODAL].some(function (fType) {
        return fType === type;
      });
    }
    /**
     * @param formID
     * @param {number} type Required!!! Whether it's the main form, the value must be -1.
     * @param additionalData
     * @param {number} rowID
     * @param {string} mode
     * @param {number} viewMode Required!!! Can be omitted only for the main form.
     * @param {object} urlObj
     * @param {string} parentUUID
     * @param {string} newLocation uses in openInNewWindow
     * @param {function} [afterChildClose]  uses in openInNewWindow
     */

  }, {
    key: "formInitialize",
    value: function () {
      var _formInitialize = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _ref2,
            formID,
            type,
            additionalData,
            rowID,
            mode,
            _ref2$viewMode,
            viewMode,
            _ref2$urlObj,
            urlObj,
            parentUUID,
            newLocation,
            afterChildClose,
            form,
            _System$VIEW_MODE,
            MODAL,
            IN_NEW_WINDOW,
            title,
            loadedEditType,
            newWMode,
            newWRowID,
            parentFormID,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _ref2 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, formID = _ref2.formID, type = _ref2.type, additionalData = _ref2.additionalData, rowID = _ref2.rowID, mode = _ref2.mode, _ref2$viewMode = _ref2.viewMode, viewMode = _ref2$viewMode === void 0 ? 1 : _ref2$viewMode, _ref2$urlObj = _ref2.urlObj, urlObj = _ref2$urlObj === void 0 ? null : _ref2$urlObj, parentUUID = _ref2.parentUUID, newLocation = _ref2.newLocation, afterChildClose = _ref2.afterChildClose;
                form = {};

                if (this.isCustomForm(type)) {
                  _context.next = 6;
                  break;
                }

                _context.next = 5;
                return loadFormMetadata(formID);

              case 5:
                form = _context.sent;

              case 6:
                _System$VIEW_MODE = System.VIEW_MODE, MODAL = _System$VIEW_MODE.MODAL, IN_NEW_WINDOW = _System$VIEW_MODE.IN_NEW_WINDOW;

                if (!(isEmptyObject(form) && !this.isCustomForm(type))) {
                  _context.next = 9;
                  break;
                }

                throw new Error(formatMessage(Messages.Errors.FormNotFound, [formID]));

              case 9:
                title = form[Fields.Title] || '', loadedEditType = form[Fields.Type];

                if (!(viewMode === IN_NEW_WINDOW)) {
                  _context.next = 15;
                  break;
                }

                newWMode = urlObj ? urlObj.mode : mode;
                newWRowID = urlObj ? urlObj.id : rowID;
                this.openInNewWindow(formID, additionalData, loadedEditType, newWMode, newWRowID, newLocation, afterChildClose);
                return _context.abrupt("return");

              case 15:
                if (!(isEmptyValue(urlObj) || this.isCustomForm(type))) {
                  _context.next = 18;
                  break;
                }

                this.appendFormObj(this.getFormObj({
                  formID: formID,
                  parentUUID: parentUUID,
                  type: type,
                  additionalData: additionalData,
                  viewMode: viewMode,
                  rowID: rowID,
                  mode: mode,
                  title: title
                }), viewMode);
                return _context.abrupt("return");

              case 18:
                if (!(viewMode === MODAL && this.parentIsSubsystem(urlObj))) {
                  _context.next = 22;
                  break;
                }

                parentFormID = urlObj.parentRoute.split('/')[1];
                _context.next = 22;
                return this.appendParentForm(parentFormID);

              case 22:
                this.appendFormObj(this.getFormObj({
                  formID: formID,
                  parentUUID: this.lastForm() && this.lastForm().UUID,
                  type: loadedEditType,
                  additionalData: additionalData,
                  viewMode: viewMode,
                  rowID: urlObj.id,
                  mode: urlObj.mode,
                  title: title
                }), viewMode);

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function formInitialize() {
        return _formInitialize.apply(this, arguments);
      }

      return formInitialize;
    }()
  }, {
    key: "openInNewWindow",
    value: function openInNewWindow(formID, additionalData, type, mode, rowID, newLocation, afterChildClose) {
      var FULL_SCREEN = System.VIEW_MODE.FULL_SCREEN;
      var url = document.location.origin + document.location.pathname;

      if (newLocation) {
        url = newLocation;
      }

      var newWin = window.open(url);

      newWin.onload = function () {
        this.D5.afterChildClose = afterChildClose;

        if (newWin.D5) {
          newWin.D5.loadForm({
            formID: formID,
            additionalData: additionalData,
            type: type,
            viewMode: FULL_SCREEN,
            mode: mode,
            rowID: rowID
          });
        }
      };
    }
  }, {
    key: "appendParentForm",
    value: function () {
      var _appendParentForm = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(parentFormID) {
        var FULL_SCREEN, subsystems, sortedCollection, _sortedCollection$, subSysFormID, subSysType, subSysTitle;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                FULL_SCREEN = System.VIEW_MODE.FULL_SCREEN;
                _context2.next = 3;
                return loadSubSystem(parentFormID);

              case 3:
                subsystems = _context2.sent;
                //может прийти несколько записей с одинаковым значением FormID, поэтому берем обьект, где значие поля Order наименьшее
                sortedCollection = _.sortBy(subsystems, Fields.Order);
                _sortedCollection$ = sortedCollection[0], subSysFormID = _sortedCollection$[Fields.FormID], subSysType = _sortedCollection$[Fields.FormID_Type], subSysTitle = _sortedCollection$[Fields.FormID_Title];

                if (subSysFormID != null) {
                  this.appendFormObj(this.getFormObj({
                    formID: subSysFormID,
                    type: subSysType,
                    viewMode: FULL_SCREEN,
                    title: subSysTitle
                  }), FULL_SCREEN);
                }

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function appendParentForm(_x) {
        return _appendParentForm.apply(this, arguments);
      }

      return appendParentForm;
    }()
  }, {
    key: "parentIsSubsystem",
    value: function parentIsSubsystem(urlObj) {
      return urlObj.parentRoute && urlObj.parentRoute.match(new RegExp(SUBSYSTEM_ROUTE));
    }
  }, {
    key: "lastForm",
    value: function lastForm() {
      return _store.modals.last() || _store.fullForm.last();
    }
  }, {
    key: "focusTable",
    value: function focusTable(tableUUID) {
      for (var table in _store.tables) {
        if (_store.tables.hasOwnProperty(table)) {
          _store.tables[table].focused = false;
        }
      }

      if (!_store.tables.hasOwnProperty(tableUUID)) _store.tables[tableUUID] = {};
      _store.tables[tableUUID].focused = true;
    }
  }, {
    key: "destructor",
    value: function destructor() {
      _store.modals = _store.modals.clear();
      _store.fullForm = _store.fullForm.clear();
    }
  }]);

  return FormStoreClass;
}(StoreClass);

var FormStore = new FormStoreClass();
AppDispatcher.register(function (action) {
  switch (action.actionType) {
    case FormConstants.FORM_INITIALIZE:
      FormStore.formInitialize(action.formObj).then(function () {
        FormStore.emit(CHANGE_EVENT);
      }).catch(function (e) {
        console.warn(e.message); // router.navigateTo(System.page404);
      });
      break;

    case FormConstants.FORM_FOCUS_TABLE:
      FormStore.focusTable(action.tableUUID);
      FormStore.emit(CHANGE_EVENT);
      break;

    case FormConstants.FORM_DESTROYED:
      var fullForm = _store.fullForm.get(action.formUUID);

      _store.modals = _store.modals.delete(action.formUUID);
      _store.fullForm = _store.fullForm.delete(action.formUUID);
      var lastIsEdit = _store.fullForm.last() && _store.fullForm.last().type === System.FORM_TYPE.EDIT;
      if (_store.fullForm.size) changeDocumentTitle(_store.fullForm.last().title);

      if (!_store.modals.size && !lastIsEdit || fullForm && fullForm.type === System.FORM_TYPE.EDIT) {
        var route = window.location.hash.match(new RegExp("^#(.*?)".concat(EDIT_FORM_ROUTE, "$")));

        if (route) {
          setTimeout(function () {
            return topBarSetDynToolBarContent(null);
          });
          FormStore.emit(CHANGE_EVENT);
          router.navigateTo(!route[1] ? '' : route[1]);
        }
      }

      FormStore.emit(CHANGE_EVENT);
      break;

    case ApplicationConstants.DO_LOGOUT:
      {
        FormStore.destructor();
        break;
      }

    default:
      return true;
  }
});
export default FormStore;